
export const getDeviceInfo = {
  methods: {
    getDeviceInfo () {
      if (this.$terminal === 'Android') {
        if (window.jdJsCallNative && window.jdJsCallNative.callNativeForJson) {
          window.jdJsCallNative.callNativeForJson('getDeviceInfo')
        }
      } else if (this.$terminal === 'IOS') {
        if (window.webkit && window.webkit.messageHandlers) {
          window.webkit.messageHandlers.callNativeForJson.postMessage({
            param: {
              event: 'getDeviceInfo'
            }
          })
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixin/getDeviceInfo.js